import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';
import { isFunction } from 'lodash';

import { StudyApi } from '../../../../../api';
import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../common/general/Button';
import ButtonGroup from '../../../../../common/general/ButtonGroup';
import { onRequestError } from '../../../../../services/handlers';
import { NS_COMMON, NSPS_STUDY } from '../../../../../services/i18n/namespaces';

import './EditTravelStudyFolderModal.scss';
export default function EditTravelStudyFolderModal({ modalBox, studyDetails, onStudyDetailsTravelFolderLinkUpdate }) {
  const { t } = useTranslation();
  const [link, setLink] = useState(studyDetails?.travelStudyFolder?.link || null);
  const [displayName, setDisplayName] = useState(studyDetails?.travelStudyFolder?.displayName || null);

  const onLinkUpdate = () => {
    const request = { link: link, displayName: displayName };
    StudyApi.updateTravelFolderLink(studyDetails.unique_identifier, request)
      .then(({ data }) => {
        isFunction(onStudyDetailsTravelFolderLinkUpdate) && onStudyDetailsTravelFolderLinkUpdate(data);
      })
      .catch(err => onRequestError(err));
    modalBox.close();
  };

  const isValidUrl = url => {
    const pattern = new RegExp('^(https?:\\/\\/)[^\\s/$.?#].[^\\s]*$');
    return pattern.test(url);
  };

  const isUrlInputError = link && link !== '' && !isValidUrl(link);

  const isSaveDisabled =
    !link ||
    isUrlInputError ||
    (studyDetails?.travelStudyFolder?.link === link && studyDetails?.travelStudyFolder?.displayName === displayName);

  return (
    <>
      <ModalBoxes.Header>{t('updateTravelStudyFolderLink', { ns: NSPS_STUDY })}</ModalBoxes.Header>
      <ModalBoxes.Body>
        <div className="edit-travel-study-folder-fields-group">
          <TextField
            label={t('link', { ns: NSPS_STUDY })}
            value={link}
            onChange={({ target: { value } }) => {
              setLink(value);
            }}
            type="text"
            variant="outlined"
            fullWidth
            size="small"
            error={isUrlInputError}
            helperText={isUrlInputError ? t('enterValidUrlLinkValidation', { ns: NSPS_STUDY }) : ''}
            required
            multiline
            maxRows={4}
          />
          <TextField
            label={t('displayNameOptional', { ns: NSPS_STUDY })}
            value={displayName}
            onChange={({ target: { value } }) => {
              setDisplayName(value);
            }}
            type="text"
            variant="outlined"
            fullWidth
            size="small"
            slotProps={{
              htmlInput: {
                maxLength: 255
              }
            }}
          />
        </div>
      </ModalBoxes.Body>
      <ModalBoxes.Footer>
        <ButtonGroup>
          <Button priority="medium" onClick={modalBox.close}>
            {t('cancel', { ns: NS_COMMON })}
          </Button>
          <Button onClick={onLinkUpdate} disabled={isSaveDisabled}>
            {t('save', { ns: NS_COMMON })}
          </Button>
        </ButtonGroup>
      </ModalBoxes.Footer>
    </>
  );
}
